export const getConfirmFlowId = state => state.confirmFlows.confirmFlow.id;
export const getConfirmFlowData = state => state.confirmFlows.confirmFlow;
export const confirmFlowIsFetching = state => state.confirmFlows.loading;